module.exports = __webpack_public_path__ + "img/Carmel Devereaux.655285ff.png";